import { loginRes } from '../Login.res';

export const res = {
  login: {
    ...loginRes.loginButtonText,
  } as const,
  continue: {
    is: 'Áfram',
    en: 'Continue',
    pl: 'Dalej',
  } as const,
};
